import type { PipelineStage } from '../types';
import { draftText } from '../draft-text';
import { getTaskTemplates } from '../../db/settings-repo';

const COMMAND_RE = /^(\/\S+)\b\s*([\s\S]*)$/;

export const e3TaskTemplates: PipelineStage = {
  id: 'E3',
  group: 'E',
  label: 'Task templates',
  description: 'Slash-command templates (/explain, /refactor, ...) expand to terse, pre-optimized instructions.',
  impact: 'Low',
  defaultEnabled: true,
  implemented: true,

  async run(draft, _params, ctx) {
    const tokensBefore = ctx.estimateTokens(draftText(draft));

    const match = draft.userMessage.trim().match(COMMAND_RE);
    if (!match) {
      return {
        draft,
        report: {
          stageId: 'E3',
          tokensBefore,
          tokensAfter: tokensBefore,
          tokensSaved: 0,
          notes: ['Message does not start with a recognized slash command.'],
        },
      };
    }

    const [, command, rest] = match;
    const templates = await getTaskTemplates();
    const expansion = templates[command];
    if (!expansion) {
      return {
        draft,
        report: {
          stageId: 'E3',
          tokensBefore,
          tokensAfter: tokensBefore,
          tokensSaved: 0,
          notes: [`"${command}" isn't a recognized task template.`],
        },
      };
    }

    // Typing a recognized slash command is itself an explicit, deliberate request for this exact
    // expansion — unlike E1's arbitrary pasted content, this isn't a silent rewrite of free text.
    const newMessage = rest ? `${expansion}\n\n${rest}` : expansion;
    const newDraft = { ...draft, userMessage: newMessage };
    const tokensAfter = ctx.estimateTokens(draftText(newDraft));

    return {
      draft: newDraft,
      report: {
        stageId: 'E3',
        tokensBefore,
        tokensAfter,
        tokensSaved: Math.max(0, tokensBefore - tokensAfter),
        notes: [`Expanded "${command}" into its pre-optimized template instruction.`],
      },
    };
  },
};
